import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'



const Id2 = () => {

    const detail = 
        {
            id:35,
            imgSrc:cover,
            ini:'LUCENT and IJL PRESTO Welcome Exchange Students from Indonesia and Japan for Laboratory Study Visit',
            href:'..//pages/news/others/welcome exchange student/index.js',
            element:'',
            topic:`LUCENT International Collaboration and International Joint Laboratory (IJL) PRESTO, Faculty of Associated Medical Sciences, Chiang Mai University, led by Asst. Prof. Dr. Woottichai Khamduang, welcomed exchange students from Universitas Islam Negeri Syarif Hidayatullah Jakarta (UIN), Indonesia, and Kobe University, Japan, for an academic study visit at The LUCENT International Collaboration on Monday, September 7, 2026.
                    <br> This study visit is part of the clinical elective program with the Faculty of Associated Medical Sciences, Chiang Mai University, providing students with the opportunity to learn laboratory research processes, explore the application of biomedical technologies, and exchange knowledge and experiences with faculty members and researchers, thereby promoting international academic collaboration and student development.`,
            inform:``,
            link1:`https://lucent.ams.cmu.ac.th/view_activity.html?id=58`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        
        
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
